export default "__VITE_ASSET__CCx2jAad__"